import React from "react";
import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import Markdown from "@/components/Markdown";
import PageContainer from "@/components/pages/COA/PageContainer";
import Title2 from "@/components/pages/COA/Title2";
import Description from "@/components/pages/COA/Description";

const TWO = 2;

const ExamDetails = ({ styles, examDetails }) => (
  <>
    <Stack sx={{ backgroundColor: "white" }}>
      <PageContainer sx={{ paddingX: 0 }}>
        <div className={styles.examDetailsContainer}>
          <div className={styles.examDetailsContent}>
            <Title2>{examDetails.title}</Title2>
            <Description>{examDetails.description}</Description>
          </div>
          <div className={styles.examDetailsLogo}>
            <div className={styles.examDetailsLogoTitle}>
              {examDetails.releaseInfo.title}
            </div>
            {examDetails.releaseInfo.logo && (
              <img
                src={examDetails.releaseInfo.logo.publicURL}
                alt={examDetails.releaseInfo.logoAlt}
                className={styles.ctaLogo}
              />
            )}
          </div>
        </div>
        <div className={styles.examDetailsList}>
          <div>
            {examDetails.details.map((detail, index) =>
              index % TWO === 0 ? (
                <div
                  key={`exam-detail-${detail.title}`}
                  className={styles.examDetailItem}
                >
                  <Markdown className={styles.examDetailsTitle}>
                    {detail.title}
                  </Markdown>
                  <Markdown className={styles.examDetailsDescription}>
                    {detail.description}
                  </Markdown>
                </div>
              ) : null
            )}
          </div>
          <div>
            {examDetails.details.map((detail, index) =>
              index % TWO === 0 ? null : (
                <div
                  key={`exam-detail-${detail.title}`}
                  className={styles.examDetailItem}
                >
                  <Markdown className={styles.examDetailsTitle}>
                    {detail.title}
                  </Markdown>
                  <Markdown className={styles.examDetailsDescription}>
                    {detail.description}
                  </Markdown>
                </div>
              )
            )}
          </div>
        </div>
      </PageContainer>
    </Stack>
    <Stack sx={{ backgroundColor: "white" }}>
      <PageContainer>
        <div className={styles.examDetailsFooter}>
          <Markdown className={styles.examDetailsFooterText}>
            {examDetails.footer.title}
          </Markdown>
          <a
            href={examDetails.footer.ctaLink}
            className={styles.examDetailsFooterLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${examDetails.footer.ctaText} (opens in new tab)`}
          >
            <Markdown className={styles.examDetailsFooterLinkText}>
              {examDetails.footer.ctaText}
            </Markdown>
            <i className="fa fa-cloud-download" aria-hidden="true" />
          </a>
        </div>
      </PageContainer>
    </Stack>
  </>
);

ExamDetails.propTypes = {
  styles: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  examDetails: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    releaseInfo: PropTypes.shape({
      title: PropTypes.string.isRequired,
      logo: PropTypes.shape({
        publicURL: PropTypes.string.isRequired
      }),
      logoAlt: PropTypes.string
    }).isRequired,
    details: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
      })
    ).isRequired,
    footer: PropTypes.shape({
      title: PropTypes.string.isRequired,
      ctaLink: PropTypes.string.isRequired,
      ctaText: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default ExamDetails;
